var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIndicatorButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7 0h9v5h-1V1H8v15H6.845l-5.077-6H0V9h2.232L7 14.635z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.5 3h-1v3.063A2 2 0 0 0 10 8v3a2 2 0 0 0 1.5 1.937V16h1v-3.063A2 2 0 0 0 14 11V8a2 2 0 0 0-1.5-1.937zm-.5 9a.996.996 0 0 0 1-1V8a1 1 0 0 0-2 0v3a1 1 0 0 0 1 1",
  clipRule: "evenodd"
})));
export default SvgIndicatorButton;